import React from 'react';
import { Spin, Card } from 'antd';
import { Link } from 'react-router-dom';
import { useCollection } from 'react-firebase-hooks/firestore';

import { ROUTE_EMPLOYER_PREFIX } from 'utils/routes';
import Client from 'containers/app/client';

const WorkersWidget = () => {
  const ref = Client.db
    .collection('booking_request')
    .where('userId', '==', Client.currentUserId())
    .where('status', '==', 'pending');

  const [collection, loading, error] = useCollection(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  const pendingRequests = collection.docs.filter((doc) => {
    const { status } = doc.data();
    return status === 'pending';
  });

  if (pendingRequests.length === 0) return null;
  //       history.push(`${ROUTE_EMPLOYER_PREFIX}/worker-search`);

  return (
    <Card
      title="Booking requests"
      extra={<Link to={`${ROUTE_EMPLOYER_PREFIX}/booking-requests`}>More</Link>}
    >
      <p>
        You have <strong>{pendingRequests.length}</strong> pending requests.
      </p>
    </Card>
  );
};

export default WorkersWidget;
